import NSNavbar from 'components/NSNavbar/NSNavbar';
import NSTopNavBarV2 from 'components/NSNavbar/NSTopNavBarV2';
import NSNavBarV2 from 'components/NSNavBarV2/NSNavBarV2';
import { SideNavCollapsedProvider } from 'components/NSNavBarV2/context/SideNavCollapsedContext';
import { Outlet } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useTypedFlags } from 'hooks/useTypedFlags';
import './LayoutWithNavbar.scss';

const LayoutWithNavbar = () => {
    const { isAuthenticated } = useAuth0();
    const { ldFlagNavbarV2 } = useTypedFlags();

    if (ldFlagNavbarV2) {
        return (
            <SideNavCollapsedProvider>
                {isAuthenticated && <NSTopNavBarV2 />}
                <div className="LayoutWithNavbarV2 d-flex align-items-stretch">
                    {isAuthenticated && <NSNavBarV2 />}
                    <div className="LayoutWithNavbarV2__content flex-fill px-3 pb-3">
                        <Outlet />
                    </div>
                </div>
            </SideNavCollapsedProvider>
        );
    }

    return (
        <>
            {isAuthenticated && <NSNavbar />}
            <div className="LayoutWithNavbar px-3 pb-3">
                <Outlet />
            </div>
        </>
    );
};

export default LayoutWithNavbar;
